import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificacionProvider } from "./context/NotificacionContext";
import { ThemeProvider } from "./context/ThemeContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { initSentry } from "./config/sentry";

// Inicializar Sentry antes de renderizar
initSentry();

// Registrar Service Worker para PWA y soporte offline
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // Comprobar actualizaciones cada hora
        setInterval(() => {
          registration.update().catch(() => {
            // El registro puede haberse invalidado si el navegador cerró/actualizó el SW
          });
        }, 60 * 60 * 1000);
      })
      .catch(error => {
        console.error('Error al registrar Service Worker:', error);
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <NotificacionProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </NotificacionProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
